import React, { Component } from 'react';

import Announcements from '../components/announcements';
import ImportantLinks from '../components/important-links';
import Intro from '../components/intro';
import CourseStructure from '../components/course-structure';
import RequiredTexts from '../components/required-texts';
import Grading from '../components/grading';
import ClassPolicies from '../components/class-policies';
import Acknowledgements from '../components/acknowledgments';

export default class HomePage extends Component {
  render() {
    return (
      <div>
        <Announcements />
        <ImportantLinks />
        <Intro />
        <CourseStructure />
        <RequiredTexts />
        <Grading />
        <ClassPolicies />
        <Acknowledgements />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/home-page.js